import { 
    AlternateEmail as AlternateEmailIcon, PhoneAndroid as PhoneAndroidIcon 
} from '@mui/icons-material';

const PackTypeIcon = ({ type, ...params }) => {
    switch (type) {
        case 'sms':
                return <PhoneAndroidIcon {...params} />;
        case 'email':
        default:
            return <AlternateEmailIcon {...params} />;
    }
};

export default PackTypeIcon;
